import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { loginUser } from '../../redux/apiRequest';

import logo from '../../assets/image/loginImg/logo.png';
import img1 from '../../assets/image/loginImg/image6.png';
import img2 from '../../assets/image/loginImg/image8.png';
import img3 from '../../assets/image/loginImg/image9.png';

import styles from "./Login.module.scss"; // Import SCSS module
import classNames from "classnames/bind";
const cx = classNames.bind(styles);

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [index, setIndex] = useState(1);

    //Xử lý UX của thẻ input
    const [inputStates, setInputStates] = useState({
        username: false,
        password: false,
    });

    const inputsRef = useRef({
        username: null,
        password: null,
    });

    const handleFocus = (field) => {
        setInputStates((prev) => ({ ...prev, [field]: true }));
    };

    const handleBlur = (field) => {
        const value = inputsRef.current[field]?.value;
        if (!value) {
            setInputStates((prev) => ({ ...prev, [field]: false }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        loginUser({ username, password }, dispatch, navigate, (err) => setError(err.message)
        );
    };

    const moveSlider = (i) => {
        setIndex(i);
    };

    useEffect(() => {
        const id = setInterval(() => {
            setIndex((prev) => (prev % 3) + 1);
        }, 3000);
        return () => clearInterval(id);
    }, []);

    return (
        <main className={cx("main")}>
            <div className={cx("box")}>
                <div className={cx("inner-box")}>
                    <div className={cx("forms-wrap")}>
                        <form className={cx("sign-in-form")} onSubmit={handleSubmit}>
                            <div className={cx("logo")}>
                                <img src={logo} alt="logo" />
                                <h4>AI Solution</h4>
                            </div>
                            <div className={cx("heading")}>
                                <h2>Welcome Back</h2>
                                <h6>Please log in!</h6>
                            </div>
                            <div className={cx("actual-form")}>
                                <div className={cx("input-wrap")}>
                                    <input
                                        type="text"
                                        ref={(el) => (inputsRef.current.username = el)}
                                        className={cx('input-field', { active: inputStates.username })}
                                        onFocus={() => handleFocus("username")}
                                        onBlur={() => handleBlur("username")}
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        required
                                    />
                                    <label className={cx("label")}>UserName</label>
                                </div>
                                <div className={cx("input-wrap")}>
                                    <input
                                        type="password"
                                        ref={(el) => (inputsRef.current.password = el)}
                                        className={cx('input-field', { active: inputStates.password })}
                                        onFocus={() => handleFocus("password")}
                                        onBlur={() => handleBlur("password")}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                    <label className={cx("label")}>Password</label>
                                </div>
                                {error && <span className={cx("form-message")}>{error}</span>}
                                <input type="submit" value="Sign In" className={cx("sign-btn")} />
                                <p className={cx("text")}>
                                    Forgotten your password? <a href="/login">Get help</a> signing in
                                </p>
                            </div>
                        </form>
                    </div>
                    <div className={cx("carousel")}>

                        <div className={cx("images-wrapper")}>
                            {[img1, img2, img3].map((imgSrc, i) => (
                                <img
                                    key={i}
                                    src={imgSrc}
                                    className={cx("image", `img-${i + 1}`, { show: index === i + 1 })}
                                    alt=""
                                />
                            ))}
                        </div>

                        <div className={cx("text-slider")}>
                            <div className={cx("text-wrap")}>
                                <div
                                    className={cx("text-group")}
                                    style={{ transform: `translateY(${-(index - 1) * 2.2}rem)` }}
                                >
                                    <h2>Marketing Solutions</h2>
                                    <h2>Strategic Consulting</h2>
                                    <h2>Integrating A.I</h2>
                                </div>
                            </div>

                            <div className={cx("bullets")}>
                                {[1, 2, 3].map(num => (
                                    <span
                                        key={num}
                                        className={cx({ active: index === num })}
                                        onClick={() => moveSlider(num)}
                                        data-value={num}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Login;
